









import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import FieldSet from '@/shared/components/field-set.component.vue';


@Component({
    components: {
        FieldSet,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
        }),
    },
})
export default class PaymentMethodWireTransfer extends Vue {
    private currentBudget!: any;
    private literals = {
        info: 'Te enviaremos un correo electrónico con la información necesaria para hacer las transferencias.',
    };
}
